import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencilAi: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPencilAi"><Path d="M19.249 12.6636L10.4863 21.4283L3.25781 22.7427L4.57227 15.5142L13.335 6.74957L19.249 12.6636Z" fill="currentColor"/><Path d="M15.543 4.54254C17.1761 2.90965 19.8239 2.90965 21.457 4.54254C23.0901 6.17564 23.09 8.82342 21.457 10.4566L20.6631 11.2496L14.749 5.33551L15.543 4.54254Z" fill="currentColor"/><Path d="M6.4 2H5.6L4.6 4.6L2 5.6V6.4L4.6 7.4L5.6 10H6.4L7.4 7.4L10 6.4V5.6L7.4 4.6L6.4 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPencilAi;
